let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8MP3q")).then(() => parcelRequire('7kKkj'));